// modules
import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setActivityBillingStatistic,
  setActivityDashboardData,
  setActivityDashboardStatistic,
  setActivityDashboardStatistics,
  setActivityDashboardSummary,
  setDashboardMeasurementList,
  setIsStatisticLoading
} from 'src/store/modules/admin/activityDashboard'
import { getMeasurementList } from 'src/store/modules/common/thunks'

// constants
import {
  CCM_DASHBOARD,
  CCM_DASHBOARD_GET_SUMMARY,
  DATE_TIME_FORMAT_FOR_SERVER,
  EXPORT_CCM_DASHBOARD,
  EXPORT_CCM_DASHBOARD_GRID,
  EXPORT_INFO_MESSAGE,
  EXPORT_RPM_DASHBOARD,
  EXPORT_RPM_DASHBOARD_GRID,
  GET_ACTIVITY_BILLING_STATISTIC,
  RPM_DASHBOARD
} from 'src/constants'
import { showInfoModal } from 'src/services/dialogs'
import { exportReport } from 'src/utils/Functions'

let latestRpmDashboardRequestId = 0
let latestCcmDashboardRequestId = 0

export const getActivityLogDashboard =
  ({ query = {} }, isRpm) =>
  async (dispatch) => {
    const requestId = isRpm
      ? ++latestRpmDashboardRequestId
      : ++latestCcmDashboardRequestId

    try {
      const {
        items = [],
        bucketStat,
        meta = {},
        statistics
      } = await httpClient.request({
        method: 'get',
        url: {
          pathname: isRpm ? RPM_DASHBOARD : CCM_DASHBOARD,
          query
        }
      })

      const isStaleResponse = isRpm
        ? requestId !== latestRpmDashboardRequestId
        : requestId !== latestCcmDashboardRequestId

      if (isStaleResponse) {
        return null
      }

      dispatch(setActivityDashboardData(items))
      dispatch(setActivityDashboardStatistics(statistics))
      dispatch(setActivityDashboardStatistic(bucketStat || {}))
      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const updateActivityLogDashboard =
  (list, { uuid: updUuid, date }, updField) =>
  async (dispatch) => {
    const updList = list.map((item) => {
      if (item.uuid === updUuid) {
        return {
          ...item,
          [updField]: date
        }
      }
      return item
    })

    await dispatch(setActivityDashboardData(updList))
  }

export const exportDashboardData = (query, dashboardType) => async () => {
  if (dashboardType === 'ccm') {
    showInfoModal({
      content: EXPORT_INFO_MESSAGE,
      okButtonProps: {
        className: 'confirm-download'
      },
      onOk: async () => {
        await exportDashboardDataRequest(query, dashboardType)
      }
    })
  } else {
    await exportDashboardDataRequest(query, dashboardType)
  }
}

export const exportDashboardDataRequest = async (query, dashboardType) => {
  const config = {
    pathname:
      dashboardType === 'ccm' ? EXPORT_CCM_DASHBOARD : EXPORT_RPM_DASHBOARD,
    query
  }
  const fileNameDefault = `billing_export_${moment().format(
    DATE_TIME_FORMAT_FOR_SERVER
  )}.xls`

  await exportReport(config, fileNameDefault)
}

export const exportDashboardGrid = (query, dashboardType) => async () => {
  const config = {
    pathname:
      dashboardType === 'ccm'
        ? EXPORT_CCM_DASHBOARD_GRID
        : EXPORT_RPM_DASHBOARD_GRID,
    query
  }
  const fileNameDefault = `billing_export_${moment().format(
    DATE_TIME_FORMAT_FOR_SERVER
  )}.xls`

  await exportReport(config, fileNameDefault)
}

export const fetchActivityBillingStatistic =
  ({ query = {} }) =>
  async (dispatch) => {
    dispatch(setIsStatisticLoading(true))

    try {
      const items = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_ACTIVITY_BILLING_STATISTIC,
          query
        }
      })

      dispatch(setActivityBillingStatistic(items))
    } catch (err) {
      catchError(err)

      dispatch(setActivityBillingStatistic({}))
    } finally {
      dispatch(setIsStatisticLoading(false))
    }
  }

export const fetchActivitySummary =
  (config = {}) =>
  async (dispatch) => {
    const { query = {} } = config

    try {
      const activitySummary = await httpClient.request({
        method: 'get',
        url: {
          pathname: CCM_DASHBOARD_GET_SUMMARY,
          query
        }
      })

      dispatch(setActivityDashboardSummary(activitySummary))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchDashboardMeasurementList =
  (config = {}) =>
  async (dispatch) => {
    const items = await getMeasurementList(config)

    dispatch(setDashboardMeasurementList(items))
  }
